import React from 'react';

import BoltIcon from '@mui/icons-material/Bolt';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';

interface IAddActionButtonProps {
	onClick: () => void;
	width: number;
}

const AddActionButton = ({ onClick, width }: IAddActionButtonProps) => (
	<MenuItem onClick={onClick} data-testid="add-action-task" sx={{ width }}>
		<ListItemIcon>
			<BoltIcon />
		</ListItemIcon>
		<Typography variant="inherit">
			{intl.tr('flows.builder.add.item.action')}
		</Typography>
	</MenuItem>
);

AddActionButton.defaultProps = {};

export default AddActionButton;
